export const userManagementAPI = {
  userEndpoint: "v1/users",
  defaultRoles: "defaultRoles",
  assignRoles: "assignRoles",
  businessUnitRoles: "/bu_list",
  suspendUser: "suspenduser",
  csvUpload: "/v1/csv-upload",
  activeUsersDownload: "/v1/active-users-report",
};

export const tenantManagementAPI = {
  tenantEndpoint: "v1/tenants",
  subscriptionstatus: "subscriptionstatus",
  usersByRoleEndpoint: "/v1/usersbyrole",
  machineCatalogEndpoint: "/v1/catalogues_tenant",
  setQuota: "/v1/tenants/quota/settings",
  notificationSetting: "/v1/tenants/notification/settings",
  pricingProfile: "/pricing_profile/settings",
  allTenantSummary: "v1/tenants/summary/all?tenantId=",
  extAndExp: "/v1/tenants/extension_expiry/settings",
  htmlTemplate: "/v1/html-upload",
  settingsList: "/settings-list",
};

export const rbacManagementAPI = {
  rbacEndpoint: "v1/roles",
  rbacPermissionEndpoint: "v1/permissions",
  rbacRolePermissionsEndpoint: "/v1/feature_role_mapping",
  rbacClonedRoleEndpoint: "/v1/feature_role_mapping",
  deleteRoleMapping: "/v1/feature_role_mapping/",
  resourcePermissionEndpoint: "/v1/resource_permissions",
};

export const userAuthenticationAPI = {
  logoutEndpoint: "v1/azure/logout_new",
  refreshTokenEndpoint: "v1/azure/refresh_token/",
  jwtTokenEndpoint: "v1/jwt-token/refresh/",
  tenantUrl: "v1/tenants/get_tenant_detail/",
  signupB2cUser: "v1/signup-b2c-user",
  login: "v1/azure/login_new",
  forgotPassword: "v1/b2c/forgot-password",
  resetPassword: "v1/b2c/reset-password ",
  azureAdUrl: "v1/azure/auth_response_new",
  localUserLogin: "v1/local-user-login",
  idpAuthEndpoint: "v1/idp/auth_response_new",
  fetchLocalUserAccessToken: "api/TokenAuth/Authenticate",
};

export const resourceManagerAPI = {
  resourceProvider: "v1/resource_provider",
  templateEndpoint: "v1/templates",
  category: "/v1/category",
  instances: "/v1/tenants/instance_list_all/",
  instancePagination: "/v1/instance",
  getVmSnapshot: "/v1/vcenter-resources",
  templates: "v1/templates",
  uploadLogo: "v1/logo-upload",
  publishTemplate: "/v1/templates/publish/",
  publishPooledTemplate: "/v1/pool_templates/publish/",
  exportTemplate: "/v1/export_templates",
  recoverTemplate: "/recover",
  cloudProvider: "/v1/cloud-provider",
  cloudTemplate: "/v1/cloud-template",
  cloudConnect: "/v1/cloud-provider-connect",
  accountDetailsAPI: "/v1/aws-account",
  cleaningJobsAPI: "/v1/aws-nuke-job",
  AwsUsageAPI: "/v1/aws-usage",
  MaintenanceSessionAPI: "/v1/aws-maintenance-session",
  MarkAsCleanAPI: "/v1/aws-nuke-job",
};

export const machineCatalogueAPI = {
  catalogues: "/v1/catalogues",
  catalogueSku: "/v1/catalogue_sku",
  catalogue_master: "/v1/catalogue_master",
  catalogExport: "/v1/export-catalogue",
  addskulist: "/v1/addskulist",
  updateMasterCatalog: "/update",
  csvUpload: "/v1/catalouge-csv",
  vm: "/v1/vm",
  categoryFilter: `/v1/catalogue_master?`,
  userId: "?userID",
  catalogueDraft: "/v1/catalogue_draft",
  updateCatalogEndpoint: "/update_sku",
  updateCatalogChanges: "/update_changes",
  catalogueMasterDraft: "/draft_list",
  updateCatalogMasterEndpoint: "/update_sku_draft",
  request: "/v1/requests",
  createVMAdmin: "/v1/vm-provision",
  checkVMCreateQuota: "/v1/tenant_quota/check_quota_vm_create",
  checkVMExtendQuota: "/v1/tenant_quota/check_extend_vm",
  resetQuota: "/v1/tenant_quota/create-vm-quota-update",
  cloudCatalog: "/v1/cloud-catalogue",
  cloudLabExtension: "/v1/cloud-lab-extension",
  cloudLab: "/v1/cloud-lab",
  cloudLabFeedback: "/v1/cloud-lab-feedback",
  cloudBatch: "/v1/cloud-batch",
  workspaceBatchReports: "/v1/cloud-lab-usage",
  workspaceBatchTenantList: "/v1/wsm/public-ws-list",
  cloudBatchExtension: "/v1/cloud-batch-extension",
  cloudLabAws: "/v1/cloud-lab-aws",
  cloudTemplateTenant: "/v1/cloud-template-tenant",
  cloudAwsCredential: "/v1/cloud-lab-aws-cred",
  planMapping: "/v1/b2c/plan_mapping",
  cloudAzureCredential: "/v1/cloud-lab-azure-cred",
  cloudGcpCredential: "/v1/cloud-lab-gcp-cred",
  listBaseTemplate: "/v1/templates",
  listExtensionAndBasePack: "/v1/get-extension-base-pack",
  applyLabExtension: "/v1/lab-extension",
  reProvision: "/v1/cloud-lab-retrigger",
  updatePolicy: "/v1/update-lab-policy",
  azureReportDownload: "/v1/azure-service-report",
  cleanUpAzure: "/v1/clean-azure-resource",
  syncBill: "/v1/cloud-lab-azure",
  awsCleanup: "/v1/cloud-lab-aws/clean_up"
};

export const myLabs = {
  labsList: "/v1/vm",
  labRating: "/v1/rate-lab",
  vmOperations: "/v1/vm-power-operations",
  search: "?searchstring=",
  extension: "/v1/extend-validity",
  extsnUpdate: "v1/vm-extend-validity",
  vmAuthConnect: "v1/vm-auth-connect",
  vmDetails: "/v1/vm-details",
  vmPoolConnect: "v1/pool/vm-connect",
  vmDuration: "/v1/vm-duration",
  vmAddOn: "/v1/vm-add-on",
  lab_instructions: "/v1/get-lab-instructions",
  instance_size_list: "/v1/tenants/instance_list",
  reconfigure_vm: "/v1/reconfigure-vm",
  reprovision_lab: "/v1/wsm/ws-re-provision",
  vmStateManageURL: "/v1/update-vm-username",
  restoreVmApiUrl: "/v1/restore-vm"
};

export const addressApi = {
  address: "/v1/address-dropdown?",
  country: "country=True",
  state: "country_id=",
  city: "state_id=",
};

export const notifcationMangement = {
  notification: "/v1/notification_templates",
  myNotifications: "/v1/my_notifications",
  listUsers: "/v1/users_list",
  search: "display_name=",
  defaultList: "/v1/notification_templates?category=1,2,3&",
  customList: "/v1/notification_templates?category=0&",
  send: "/v1/user_notifications",
};

export const tenantId = "ea584c0e-68db-486e-88ca-f613c2a0951b";

export const requestManagerAPI = {
  requestsList: "/v1/requests",
  trackRequest: "/v1/requests/get_track",
  setReqStatus: "/v1/requests",
  deploymentList: "/v1/deployment-jobs",
  reqestLab: "/v1/request-ticket",
  resendNotification: "/v1/request/notify",
  exportRequest: "/v1/request-report",
  bulkUpdateRequest: "/v1/bulk-request",
};

export const actionLogApi = {
  actionLogsList: "/v1/get-action-log",
  actionLogDownload: "/v1/download-action-log",
};

export const notificationsApi = {
  notificationsList: "/v1/notification_master",
};

export const webSocket = {
  ticket: "/v1/ticket",
};

export const headerNotification = {
  userNotification: "/v1/user_notifications",
  markAll: "mark_all_read",
};

export const dashboardApi = {
  resourceProviderList: "/v1/resource_provider",
  resourcesInfo: "/v1/dashboard-resource-provider-stats",
  tenantStats: "/v1/dashboard-tenant-stats",
  userStats: "/v1/dashboard-user-stats",
  usersDropDown: "/v1/dashboard-dropdown",
  pendingActCount: "/v1/pending-request",
  vmStats: "/v1/dashboard-vm-stats",
  vmStatsTenantUser: "/v1/dashboard-tenant-user-vm-stats",
  billingInfo: "/v1/billing-data",
  VMDetails: "/v1/vm-details",
  trendingLabs: "/v1/catalogue_sku",
  usageTrends: "/v1/dashboard-usage-trends",
  vmUsageMonth: "/v1/vm-usage-month",
  cloudVmBilling: "/v1/cloud-vm-billing",
  usageHours: "/v1/tenant-usage-details",
  billingForecast: "/v1/predict",
  usage: "/v1/usage",
  resourceProviderCount: "/v1/cloud-provider/resource-provider-count",
  vmInfo: "/v1/vm/vm_stats"
};

export const notificationSettings = {
  notificationTypes: "/v1/user/notification_settings",
  updateProfile: "/v1/user/update-profile",
  reportTypes: "/v1/user/report-settings",
};

export const usage = {
  usageEndpoint: "/v1/billing-data",
  usageReport: "/v1/usage-report",
  usageReportSkuEndpoint: "/v1/catalogue_sku",
  usageUserList: "/v1/users",
  publicUsageReport: "/v1/cloud-public-lab-usage",
};

export const workspaceManager = {
  createWorkSpace: "/v1/wsm/workspace",
  createResource: "/v1/wsm/workspace-resources",
  authConfig: "/v1/wsm/workspace-auth-config",
  resourceTemplates: "/v1/catalogues_tenant",
  workspaceUsers: "/v1/wsm/invitation",
  instanceSizePricing: "/v1/tenants/instance-size-pricing",
  workspaceAction: "/v1/wsm/workspace-status",
  workspaceResource: "/v1/wsm/vm-resource",
  linkDelink: "/v1/wsm/vm-action",
  listUserInivitation: "/v1/wsm/invitation",
  workspaceInvitation: "/v1/wsm/export-invitations",
  getInvitationLink: "v1/wsm/create-common-invite",
  resendInvitation: "/v1/wsm/resend-invitations",
  getWorkspaceTenants: "/v1/wsm/workspace-tenants",
  getWorkspaces: "/v1/wsm/workspace-list",
  usageReports: "/v1/usage-report",
  getInvitation: "/v1/wsm/login",
  extend: "/v1/wsm/workspace-extensions",
  checkVMExtendQuota: "/v1/wsm/checkquota-vmextend",
  updateQuota: "v1/wsm/updatequota",
  createQuota: "/v1/wsm/checkquota-vmcreate",
  getWorkSpaceAuthResponse: "/v1/azure/auth_response",
  tenantListForWorkspace: "/v1/wsm/ws-tenants",
  workspaceUser: "/v1/wsm/workspace-user",
  addWorkspaceResources: "/v1/wsm/workspace-vm",
  getAllSkuCloudVM: "/v1/cloud-vm-workspace",
  publicWsDetails: "/v1/wsm/public-ws-details",
  azureCloudVMResources: "/v1/cloud-vm"
};

export const userWorkspaceManager = {
  userWorkspaceLabsList: "/v1/wsm/ws-vm-details",
  userWorkspaceLabTimer: "/v1/wsm/workspace-session",
};

export const directLoginApis = {
  verifyDemandLogin: "/v1/ondemand-login",
  getDemandLoginToken: "/v1/ondemand/auth_response_new",
};

export const vmInsight = {
  getVmInsightEndPoint: "/v1/vm-insights",
  vmTenantsList: "/v1/tenants",
  tenantBasedUsers: "/v1/users?tenant=",
  getVmInsightsDetails: "/v1/vminsights",
};

export const b2c = {
  plan: "/v1/b2c/plan",
  planMapping: "/v1/b2c/plan_mapping",
  freeTrial: "/v1/b2c/free-trial",
  b2cCatalog: "/v1/catalogue-sku-b2c",
  latestPurchases: "/v1/b2c/purchase_lab",
  b2cVmLabs: "/v1/vm",
  search: "?is_b2c_vm=true&sku_name=",
  addIntoCart: "/v1/b2c/cart_items",
  checkout: "/v1/b2c/checkout",
  paymentCallback: "/v1/b2c/payment_callback",
  paymentReceipt: "/v1/b2c/payment_receipt",
};
export const invoicing = {
  generateInvoice: "/v1/invoice/generate",
  uploadInvoiceTemplate: "/v1/invoice/upload_template",
};

export const resellerLicense = {
  licenceList: "/v1/licence",
  delLicense: "/v1/licence",
  updateLicense: "/v1/licence",
  allLicenseSummary: "/v1/sync-licence/summary/all?id=",
  licenseStats: "/v1/license-stats",
};
export const customReporting = {
  customFilterList: "/v1/report-engine-schema",
  customReport: "/v1/custom-data",
};

export const publicResourceManager = {
  cloud_vm_list: "/v1/cloud-vm-list",
  cloudVM: "/v1/cloud-vm",
  cloudProviderAzureList: "/v1/cloud-provider-azure-list",
  getToken: "/get-token",
  rg_stats: "/v1/cloud-dashboard-stats",
  cloud_provider: "/v1/cloud-provider",
  // Azure image-catalog cascade endpoints
  azureImageCatalog: "/v1/public/azure/image-catalog",
  azureGalleries: "/v1/public/azure/image-catalog/galleries",
  azureGalleryImages: "/v1/public/azure/image-catalog/images",
  azureImageVersions: "/v1/public/azure/image-catalog/versions", // TODO: confirm path
  // Standalone dropdown endpoints
  // TODO: replace with real endpoints when available
  azureRegions: "/v1/azure-regions",
  azureInstanceSizes: "/v1/cloud-vm-workspace",
  // Azure VM Template — create / list
  azureVmTemplates: "/v1/public/azure/image-catalog/templates",
  // Azure VM Template — update (provider_id + template_name go as query params)
  // Full URL: /v1/public/azure/image-catalog/template?provider_id=...&template_name=...
  azureVmTemplateUpdate: "/v1/public/azure/image-catalog/template",
  // Azure VM Template — fetch by IDs
  // Full URL: /v1/public/azure/image-catalog/template-by-id?provider_id=...&template_id=...
  azureVmTemplateById: "/v1/public/azure/image-catalog/template-by-id",
  // Azure VM Template — retrieve / delete  (id goes between base path and /template)
  // Full URL: /v1/public/azure/image-catalog/{template_id}/template
  azureVmTemplateBase: "/v1/public/azure/image-catalog",
  azureVmSkuPublish: "/v1/public/azure/image-catalog/sku",
};
